import React, { useEffect } from 'react'
import { Form, Input, InputNumber, Tabs } from 'antd'
import { UseFormReturnType } from 'interfaces/refine'
import { ICuisine } from 'interfaces/catering'
import { SingleImageUpload } from 'components/input'
import { AttributeMappingForm } from 'components/attributes/AttributesMappingForm'
import { file2Base64 } from '@refinedev/core'

export const CuisineForm: React.FC<{
  useFormProps: UseFormReturnType<ICuisine>
}> = ({ useFormProps }) => {
  const { formProps, queryResult } = useFormProps
  const form = formProps.form
  const cuisineData = queryResult?.data?.data

  useEffect(() => {
    if (cuisineData) {
      form?.setFieldsValue({
        ...cuisineData,
        attributes: cuisineData.attributes || [],
      })
    }
  }, [cuisineData, form])

  const onFinish = async (values: any) => {
    const { image: uploadedImage, attributes, ...rest } = values
    let image = null

    if (uploadedImage) {
      const file = uploadedImage[uploadedImage.length - 1]
      if (file?.originFileObj) {
        image = await file2Base64(file)
      }
    }

    const cleanedAttributes = attributes?.map((attr: any) => ({
      id: attr.id,
      attribute: attr.attribute,
      order: attr.order || 1,
    }))

    const payload: any = {
      ...rest,
      attributes: cleanedAttributes ?? [],
    }

    // Only include image if user re-uploaded
    if (image) payload.image = image

    return formProps?.onFinish?.(payload)
  }

  return (
    <Form
      {...formProps}
      layout="vertical"
      onFinish={onFinish}
      id="cuisine-form">
      <Tabs>
        <Tabs.TabPane tab="Basic Info" key="basic">
          <SingleImageUpload
            label="Image"
            name="image"
            initialImageUrl={
              cuisineData?.optimized_image || cuisineData?.image || ''
            }
          />
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Cuisine name is required' }]}>
            <Input />
          </Form.Item>

          <Form.Item label="Order" name="order" initialValue={1}>
            <InputNumber />
          </Form.Item>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Attributes" key="attributes" forceRender>
          <AttributeMappingForm name="attributes" relationField="cuisine" />
        </Tabs.TabPane>
      </Tabs>
    </Form>
  )
}
